<template>
    <div class="container">
        <div class="wel-box">
            <div class="top-box">
                <homeHead ref="homeHead" />
            </div>
            <div class="studio-container">
                <div class="left-menu-container">
                    <studio-menu :item-num="this.activeItem"
                                 studio-nature="3"
                                 @change-item="changeItem"/>
                </div>
                <!--概览-->
                <div v-if="activeItem==='1'" class="right-content-container">
                    <studio-overview studio-nature="3"
                                     @change-parent-item="changeParentItem"/>
                </div>
                <!--工作室查询-->
                <div v-if="activeItem==='2'" class="right-content-container">
                    <studio-query studio-nature="3"/>
                </div>
                <!--工作室成果-->
                <div v-if="activeItem==='3'" class="right-content-container">
                    <studio-achievement studio-nature="3"
                                        :achieve-mode="this.achieveMode"
                                        @change-mode="changeMode"/>
                </div>
                <!--工作室咨询-->
                <div v-if="activeItem==='4'" class="right-content-container">
                    <studio-news studio-nature="3"
                                 :news-mode="this.newsMode"
                                 @change-mode="changeMode"/>
                </div>

            </div>
        </div>
    </div>
</template>
<script>
import {timestampToTime} from "@/utils/date";
import homeHead from "@/components/homeHead.vue";
import studioOverview from "@/components/studio/studioOverview";
import studioQuery from "@/components/studio/studioQuery";
import studioAchievement from "@/components/studio/studioAchievement";
import homeFooter from "@/components/homeFooter";
import studioMenu from "@/components/studio/studioMenu.vue";
import studioNews from "@/components/studio/studioNews.vue";

export default {
    components: {studioNews, studioMenu, homeHead,studioOverview,studioQuery,studioAchievement,homeFooter},
    name: "studioHome",
    data() {
        return {
            pageMode:"page",
            detailMode:"detail",
            timestampToTime,
            activePath: "rectorStudioHome",
            activeItem:"1",
            achieveMode:'page',
            newsMode:'page',
        }
    },
    computed: {},
    watch: {},
    created() {},
    mounted() {
        this.activePath = this.$store.state.params.jumpParams.activePath;
        this.activeItem = this.$store.state.params.jumpParams.activeItem;
        this.$refs.homeHead.activePath = this.activePath;
    },
    methods: {
        changeItem(item){
            this.$store.commit("params/setJumpParams", {});
            this.activeItem = item;
            if (item==='3'){
                this.achieveMode = this.pageMode;
            }
            if (item==='4'){
                this.newsMode = this.pageMode;
            }
        },
        changeParentItem(activeItem){
            this.activeItem = activeItem;
        },
        changeMode(item,i){
            if (i==='3'){
                this.achieveMode = item;
            }
            if (i==='4'){
                this.newsMode = item;
            }
        },
    }
}
</script>
<!--内联样式-->
<style lang="scss" scoped>
.container {
    width: 100%;
    height: 100%;
    margin: 0;
    overflow-y: auto!important;
    overflow-x: hidden;
    background-color: #f1f1f1;
}
.wel-box {
    width:100vw;
    height: auto;
    overflow-y: auto!important;
    .top-box{
        display: flex;
        width: 100vw;
        height: 70px;
        background: #ff7f2e;
    }
}
.studio-container{
    width: 100%;
    height: auto;
    border: 10px;
    box-sizing: border-box;
    display: flex;
}
.left-menu-container{
    width: 200px;
    height: auto;
    padding: 10px;
    box-sizing: border-box;
}
.menu-container{
    width: 100%;
    height: calc(100vh - 120px);
    background: #dfe4f7;
    padding-top: 15px;
    padding-bottom: 15px;
    border-radius: 10px;
}
.menu-item{
    width: 100%;
    height: 50px;
    line-height: 50px;
    text-indent: 15px;
    font-size: 15px;
    color: #707070;
    cursor: pointer;
}
.menu-active{
    background: #ff7f2e;
    color: #fff;
    //font-weight: bold;
}
.right-content-container{
    width: calc(100% - 200px);
    height: auto;
    padding: 10px;
    box-sizing: border-box;
}
.content-container{
    width: 100%;
    height: 100%;
    box-sizing: border-box;
}

</style>
